import { Chip } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid';

import { wrapAndCenterHeader } from './columnStyling';

/** A helper to generate some params for a number MUI column. */
const addNumberColumnProps = (
  headerName: string,
  showInsideChip = false,
  width = 105,
): Partial<GridValidRowModel> => ({
  type: 'number',
  headerName, // This is used as a label by the filter's component
  width,
  headerAlign: 'center',
  align: 'center',
  renderHeader: () => wrapAndCenterHeader(headerName),
  ...(showInsideChip && {
    renderCell: ({ value }) => <Chip label={value} sx={{ minWidth: 32 }} />,
  }),
});

export default addNumberColumnProps;
